import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  customerInfo: JSON.parse(localStorage.getItem('CustomerAddressData'))?.customerInfo || null,
  addresses: JSON.parse(localStorage.getItem('CustomerAddressData'))?.addresses || [],
  loading: false,
  error: null,
};

const customerAddressSlice = createSlice({
  name: 'customerAddress',
  initialState,
  reducers: {
    setCustomerAddressData: (state, action) => {
      const { customerInfo, addresses } = action.payload;

      const validAddresses = Array.isArray(addresses) ? addresses : [];

      state.customerInfo = { ...state.customerInfo, ...customerInfo };
      state.addresses = [...state.addresses, ...validAddresses];
      state.loading = false;

      const updatedData = {
        customerInfo: state.customerInfo,
        addresses: state.addresses,
      };

     
      localStorage.setItem('CustomerAddressData', JSON.stringify(updatedData));
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearCustomerAddressData: (state) => {
      state.customerInfo = null;
      state.addresses = [];
      localStorage.removeItem('CustomerAddressData');
    },
  },
});

export const { setCustomerAddressData, setLoading, setError, clearCustomerAddressData } = customerAddressSlice.actions;
export default customerAddressSlice.reducer;
